var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 11C9.16667 11.4862 9.35982 11.9525 9.70364 12.2964C10.0475 12.6402 10.5138 12.8333 11 12.8333C11.4862 12.8333 11.9525 12.6402 12.2964 12.2964C12.6402 11.9525 12.8333 11.4862 12.8333 11C12.8333 10.5138 12.6402 10.0475 12.2964 9.70364C11.9525 9.35982 11.4862 9.16667 11 9.16667C10.5138 9.16667 10.0475 9.35982 9.70364 9.70364C9.35982 10.0475 9.16667 10.5138 9.16667 11Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11C17.05 14.6667 14.3 16.5 11 16.5C7.7 16.5 4.95 14.6667 2.75 11C4.95 7.33333 7.7 5.5 11 5.5C14.3 5.5 17.05 7.33333 19.25 11Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.65bbce8ddd6620e4f0db05ad2ff4684c.svg";
export { ForwardRef as ReactComponent };